/* CS Lash 13/10/2026: botão «Adicionar os [n] ao carrinho» da secção Coleção favorita.
   Junta todos os produtos da secção de uma vez e atualiza a gaveta do carrinho pelo mesmo
   caminho que o tema usa (FoxThemeCartHelpers + evento cartUpdate). */
if (!customElements.get("cs-adicionar-todos")) {
  customElements.define(
    "cs-adicionar-todos",
    class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector("button");
        this.button.addEventListener("click", this.onClick.bind(this));
      }

      getSectionsToBundle() {
        const sections = [];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections } })
        );
        const cartDrawer = document.querySelector("cart-drawer");
        const mainCart = document.querySelector("cart-items");
        if (cartDrawer) sections.push(...cartDrawer.getSectionsToRender().map((s) => s.id));
        if (mainCart) sections.push(...mainCart.getSectionsToRender().map((s) => s.section));
        return sections;
      }

      async onClick() {
        if (this.button.classList.contains("btn--loading")) return;
        this.button.classList.add("btn--loading");
        this.button.setAttribute("aria-disabled", true);

        const items = this.dataset.ids
          .split(",")
          .filter(Boolean)
          .map((id) => ({ id: Number(id), quantity: 1 }));
        const { FoxThemeSettings, FoxThemeStrings, FoxTheme } = window;

        try {
          const response = await fetch(`${FoxThemeSettings.routes.cart_add_url}.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items }),
          });
          const result = await response.json();

          if (result.status) {
            FoxTheme.Notification.show({
              target: document.body,
              method: "appendChild",
              type: "warning",
              message: result.description || result.message,
              last: 3000,
              sticky: true,
            });
          }

          // Mesmo com erro de stock, parte dos produtos pode ter entrado: volta a ler o carrinho.
          const state = await FoxThemeCartHelpers.getState();
          FoxThemeCartHelpers.updateCartCount(state.item_count);

          const sectionIds = this.getSectionsToBundle();
          let sections = {};
          if (sectionIds.length > 0) {
            const res = await fetch(`${window.location.pathname}?sections=${sectionIds.join(",")}`);
            sections = await res.json();
          }

          if (!result.status && (!FoxThemeSettings.cart.openDrawerWhenAdded || FoxThemeSettings.cart.cartType === "page")) {
            FoxTheme.Notification.show({
              target: document.body,
              method: "appendChild",
              type: "success",
              message: FoxThemeStrings.item_added,
              last: 3000,
              sticky: true,
            });
          }

          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, { ...state, sections });
        } catch (e) {
          console.error(e);
        } finally {
          this.button.classList.remove("btn--loading");
          this.button.removeAttribute("aria-disabled");
        }
      }
    }
  );
}
